<template>
	<div class="cta">
		<b-container>
			<b-row class="cover">
				<b-col cols="12" md="6" >
					<h2 class="ttl">Рассчитать стоимость
						слаботочных систем</h2>
					<div class="button-container" @click="$root.showCallback()">
						<slot name="button"></slot>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
	//const axios = require('axios');
	export default {
		data() {
			return {}
		}
	}
</script>

<style lang="scss" scoped>
	
	.cta {
		background-image: url("~@/assets/img/cta_bg.png");
		background-size: cover;
		background-repeat: no-repeat;
		padding: 85px 0;
		@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
			background-position: 77% 0;
			height: 468px;
		}
		
		.cover {
			@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
				background: rgba(135, 29, 21, 0.8);
			}
		}
		
		.ttl {
			font-weight: 500;
			font-size: 44px;
			line-height: 110.1%;
			color: #FFFFFF;
			margin-bottom: 20px;
			@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
				font-size: 30px;
				margin-top: 14px;
			}
		}
		
		.button-container {
			width: 200px;
			height: 50px;
			@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
				margin-bottom: 15px;
			}
		}
	}

</style>